(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initGaleria() {
    var main = document.querySelector('[data-mt-gal-main]');
    if (!main) return;
    var thumbs = document.querySelectorAll('[data-mt-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full');
        main.removeAttribute('srcset');
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  function money(cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: f }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function initCompra() {
    var root = document.querySelector('[data-mt-buy]');
    if (!root) return;
    var dataEl = root.querySelector('script[type="application/json"]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('form');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-mt-add]');
    var priceEl = root.querySelector('[data-mt-price]');
    var msg = root.querySelector('[data-mt-msg]');
    var qty = form.querySelector('input[name="quantity"]');

    function actual() {
      var sel = [];
      root.querySelectorAll('.mt-opt').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        sel.push(c ? c.value : null);
      });
      if (!sel.length) return variants[0];
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function pintar() {
      var v = actual();
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-no'); return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-sold');
      if (priceEl) {
        priceEl.innerHTML = money(v.price) + (v.compare > v.price ? ' <s>' + money(v.compare) + '</s>' : '');
      }
    }
    root.querySelectorAll('.mt-opt input').forEach(function (i) { i.addEventListener('change', pintar); });

    root.querySelectorAll('[data-mt-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qty.value, 10) || 1;
        n += parseInt(b.getAttribute('data-mt-q'), 10);
        qty.value = Math.max(1, n);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = btn.getAttribute('data-wait');
      fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: idInput.value, quantity: parseInt(qty.value, 10) || 1 })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'error');
          msg.textContent = btn.getAttribute('data-ok');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (s) { s.textContent = c.item_count; });
            document.dispatchEvent(new CustomEvent('mt:cart-updated', { detail: c }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.open) { drawer.open(); }
          });
        })
        .catch(function (err) { msg.textContent = btn.getAttribute('data-err') + ' ' + (err.message || ''); })
        .finally(function () { btn.disabled = false; btn.textContent = original; });
    });

    var sticky = document.querySelector('[data-mt-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        sticky.classList.toggle('mt-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      });
      io.observe(btn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
    pintar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initGaleria();
    initCompra();
  });
})();
